import { RouteObject } from 'react-router-dom';

import JSEditProfile from 'Components/jobseekersSide/JSEditProfile';
import JSMailDetail from 'Components/jobseekersSide/JSMailDetail';

import JSChangePhoto from 'Components/jobseekersSide/JSChangePhoto';

import { JSAddAlert } from './feature-alert-add-edit';
import { JSAppliedJobs } from './feature-applied-jobs-browser';
import { JSChangePassword } from './feature-change-password';
import { FeatureCreateResume } from './feature-create-resume';
import { CandidateAppliedView } from './feature-job-applied-view';
import { JSMailHistory } from './feature-mailing-history';
import { FeatureManageAlerts } from './feature-manage-alerts';
import { FeatureManageCvs } from './feature-manage-cv';
import { JSMyCVList } from './feature-resume-browser';
import { FeatureSavedJobs } from './feature-saved-jobs';
import { FeatureUserProfile } from './feature-user-profile';
import { JSMyCV } from './feature-browse-cv';


export const CANDIDATE_ROUTES: RouteObject[] = [
   {
      path: '/alerts/index',
      Component: FeatureManageAlerts,
   },
   {
      path: '/alerts/add',
      Component: JSAddAlert,
   },
    {
      path: 'candidates/uploadPhoto',
      Component: JSChangePhoto,
   },
   {
      path: '/alerts/edit/:slug',
      Component: JSAddAlert,
   },
   {
      path: '/candidates/my-cv-list',
      Component: JSMyCVList,
   },
   {
      path: '/candidates/my-cv-list/:id',
      Component: JSMyCV,
   },
   {
      path: '/candidate/create-resume',
      Component: FeatureCreateResume,
   },
   {
      path: '/candidates/my-cv-list',
      Component: FeatureManageCvs,
   },
   {
      path: '/candidate/saved-jobs',
      Component: FeatureSavedJobs,
   },
   {
      path: '/candidate/applied-jobs',
      Component: JSAppliedJobs,
   },
   {
      path: '/candidate/mailing-history',
      Component: JSMailHistory,
   },
   {
      path: '/candidates/job-applied-view/:id',
      Component: CandidateAppliedView,
   },
   {
      path: '/candidate/profile',
      Component: FeatureUserProfile,
   },
   {
      path: '/candidate/change-password',
      Component: JSChangePassword,
   },
   {
      path: '/candidates/maildetail/:slug',
      Component: JSMailDetail,
   },

   /**
    *  CV Create-Edit-Copy
    */
   {
      path: '/candidate/edit-resume',
      Component: JSEditProfile,
   },
   {
      path: '/candidates/editCV/:id',
      Component: JSEditProfile,
   },
   {
      path: '/candidates/copyCV/:id',
      Component: JSEditProfile,
   },
];
